import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { loadHome } from '@/services/dashboard.js'

export function useDashboardHome() {
  const [home, setHome] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    setLoading(true)
    loadHome()
      .then(({ data }) => {
        if (active) setHome(data)
      })
      .catch(() => {
        if (active) toast.error('Falha ao carregar dados do dashboard.')
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [])

  return { home, loading }
}
